module.exports = __webpack_public_path__ + "img/dz.48c103f6.svg";